import React, { Component } from "react";
import autobahn from "autobahn-browser";
import axios from "axios";

const url = "ws://172.33.1.8:8080/ws";
const realm = "dappnode_admin";

class N extends Component {
    constructor(props) {
        super();
        this.state = {
            hash: undefined,
            connectedToDAppNode: false,
            session: undefined,
            storemanifest: undefined,
            packagemanifest: undefined,
            props: props,
            wsresult: undefined,
            installButtonEnabled: true,
            packagesList: undefined,
        };
    }

    peerConnect = (peer) => {
        // debugger;
        console.log(`connecting to ${peer}`);
        throw new Error("oops");
        const apiLink = `http://172.33.1.5:5001/api/v0/swarm/connect?arg=${peer}`;
        axios
            .post(
                apiLink
            )
            .then(res => {
                // debugger;
                console.log(res);
            })
            .catch(error => {
                // debugger;
                console.log(`Failed to connect to ${apiLink}`, error.message);
            });
    };

    componentDidMount() {
        const connection = new autobahn.Connection({
            url,
            realm
        });

        connection.onopen = session => {
            console.log("CONNECTED to \nurl: " + url + " \nrealm: " + realm);
            this.setState({
                connectedToDAppNode: true,
                wifichanged: false,
                targetSSID: undefined
            });
            this.setState({ session: session });
            console.log("requesting package list");
            session.call("listPackages.dappmanager.dnp.dappnode.eth").then(res => {
                res = JSON.parse(res);
                let packagesList = {};
                res.result.forEach(p => {
                    console.log(p.packageName);
                    packagesList[p.packageName] = p;
                });
                console.log(packagesList);
                this.setState({ packagesList: packagesList });
            });
        };

        // connection closed, lost or unable to connect
        connection.onclose = (reason, details) => {
            this.setState({ connectedToDAppNode: false });
            console.error("CONNECTION_CLOSE", { reason, details });
        };



        connection.open();

        // fetch manifest

        axios
            .get(
                `https://bo.ava.do/value/store`
            )
            .then(res => {
                const store = JSON.parse(res.data);
                const storeHash = store.hash;

                if (store && store.ipfsHostNodes) {
                    store.ipfsHostNodes.map(this.peerConnect);
                }
                

                axios
                    .get(
                        `http://80.208.229.228:8080/ipfs/${storeHash}`
                    )
                    .then(res => {
                        const storeManifest = res.data;

                        if (storeManifest && storeManifest.ipfsHostNodes) {
                            storeManifest.ipfsHostNodes.map(this.peerConnect);
                        }
                        this.setState({ storemanifest: storeManifest });
                        // setStoreManifest(res.data);
                    })
                    .catch(error => {
                        //debugger;
                    });
            }).catch(error => {
                console.log(`Error caught`,error.message);
                //debugger;
            });
        ;

        // debugger;

        if (this.state.props && this.state.props.match.params.hash) {
            //  debugger;
            axios
                .get(
                    `http://80.208.229.228:8080/ipfs/${this.state.props.match.params.hash}`
                )
                .then(res => {
                    const packageManifest = res.data;

                    this.setState({ hash: this.state.props.match.params.hash, packagemanifest: packageManifest });
                    // setStoreManifest(res.data);
                })
                .catch(error => {
                    console.log(error);
                });

            ;
        }
    }


    installIt = () => {
        this.setState({ installButtonEnabled: false });
        this.state.session.call("installPackage.dappmanager.dnp.dappnode.eth", [], {
            // id: "vipnode.dnp.dappnode.eth@QmTST9XeQccKJPRwebkqteHVsAQndPdxpCRsAexjoGtYya",
            id: `${this.state.packagemanifest.name}@${this.state.hash}`,
            options: {},
            userSetEnvs: {},
            userSetPorts: {},
            userSetVols: {}
        }).then(res => {
            this.setState({ installButtonEnabled: true });
            const r = JSON.parse(res);
            this.setState({ wsresult: r });
            console.log(res);
        }).catch((e) => {
            this.setState({ installButtonEnabled: true });
            this.setState({ wsresult: e });
        });
    }


    render() {

        let list = [];
        if (this.state.storemanifest && this.state.storemanifest.packages) {
            list = this.state.storemanifest.packages.sort((a, b) => { console.log(a.manifest.name); return (a.manifest.name > b.manifest.name) ? 1 : -1 }).map((p, i) => {
                // debugger;
                return (
                    <li key={i}><a href={`./${p.manifest.hash}`}>{p.manifest.name} {p.manifest.version}</a></li>
                )
            })
        }


        return (
            <div>
                <section className="section hero is-fullheight has-avado-bg">

                    <div className="hero-body is-vcentered">
                        <div className="container has-text-left has-text-white">
                            <h1 className="title is-1">AVADO</h1>
                            <h2 className="title is-2">DappStore manual installer</h2>

                            {/* <h2>AVADO DappStore manual installer</h2> */}
                            {this.state.connectedToDAppNode && (
                                <>
                                    {/* <div className="has-text-centered is-size-7">
                                <span className="tag is-primary">Connected</span>
                                <span> Great! Your AVADO is online.</span>
                            </div> */}
                                    <div>

                                        {this.state.hash ? (

                                            <>

                                                {!this.state.wsresult && (
                                                    <>
                                                        <div>Requesting manual install of package <b>{this.state.hash}</b></div>
                                                        <div>
                                                            {!this.state.packagemanifest ? (
                                                                <div className="button is-loading">Loading manifest...</div>
                                                            ) : (
                                                                    <>
                                                                        <div>Name: {this.state.packagemanifest.name}</div>
                                                                        <div>Version: {this.state.packagemanifest.version}</div>
<br/>
                                                                        <button className="button" disabled={!this.state.installButtonEnabled} onClick={this.installIt}>Install package</button>
                                                                    </>
                                                                )}
                                                        </div>
                                                    </>
                                                )}
                                                {this.state.wsresult && this.state.wsresult.success && (
                                                    <>
                                                        <article className="message is-info">
                                                            <div className="message-header">
                                                                <p>Success</p>
                                                            </div>
                                                            <div className="message-body">
                                                                <div>{this.state.wsresult.message}</div>
                                                                <a className="button" href="http://my.ava.do">Go to AVADO admin</a>
                                                            </div>
                                                        </article>
                                                        <div className="">
                                                        </div>
                                                    </>
                                                )}

                                                {this.state.wsresult && !this.state.wsresult.success && (
                                                    <b>ERROR: {this.state.wsresult.message}</b>

                                                )}
                                            </>
                                        ) : (
                                                <div>{list}</div>

                                            )}

                                    </div>
                                </>
                            )}
                            {!this.state.connectedToDAppNode && (
                                <div>
                                    <p className="has-text-centered">Connecting to your AVADO.</p>
                                    <div className="has-text-centered">
                                        <div className="button is-loading">Loading</div>
                                    </div>
                                    <p className="has-text-centered">
                                        If this is the first time you boot your AVADO - please use the
                WiFi with SSID <b> AVADO </b>
                                and password <b> avado123 </b>.
              </p>
                                </div>
                            )}
                            {/* </div> */}
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default N;
